export function getTruncatedString(options) {
  const { val, len, appendClosingQuote } = options
  // enforce valid inputs
  if (
    typeof val === 'number' ||
    typeof val === 'object' ||
    typeof val === 'function' ||
    typeof len !== 'number'
  ) {
    return ''
  }

  const truncatedString = val || ''
  return truncatedString.length < len + 1
    ? truncatedString
    : appendClosingQuote
    ? truncatedString.substring(0, len - 1) + ' ..."'
    : truncatedString.substring(0, len - 1) + ' ...'
}

export function capitalizeWord(word) {
  return word.charAt(0).toUpperCase() + word.slice(1)
}



// WEBPACK FOOTER //
// ./src/utils/string.js